export default __webpack_public_path__ + "static/media/imageDesignContentOne.a81d3a8d.png";